"use client";

import { useEffect } from "react";
import { Toaster as Sonner, toast, type ToasterProps } from "sonner";

// Lifts toasts above the Queue Console's fixed bottom action bar (issue #961)
// so they stop covering Complete / Skip / Help. The action bar is ~58px tall;
// 80px gives a comfortable gap.
const TOAST_OFFSET = 80;

const Toaster = ({ ...props }: ToasterProps) => {
  // Click anywhere on a toast to dismiss it (issue #961). Skip clicks on
  // interactive elements inside the toast so the version-drift toast's
  // "Refresh now" action button still fires its own handler.
  useEffect(() => {
    const handler = (e: MouseEvent) => {
      const target = e.target as HTMLElement | null;
      if (!target) return;
      if (target.closest("button, a, input, [data-button]")) return;
      const li = target.closest("li[data-sonner-toast]");
      if (!li) return;
      const id = li.getAttribute("data-id");
      if (id) toast.dismiss(id);
    };
    document.addEventListener("click", handler);
    return () => document.removeEventListener("click", handler);
  }, []);

  return (
    <Sonner
      className="toaster group"
      offset={TOAST_OFFSET}
      mobileOffset={TOAST_OFFSET}
      toastOptions={{
        classNames: { toast: "cursor-pointer" },
      }}
      style={
        {
          "--normal-bg": "var(--popover)",
          "--normal-text": "var(--popover-foreground)",
          "--normal-border": "var(--border)",
        } as React.CSSProperties
      }
      {...props}
    />
  );
};

export { Toaster };
